export class Step {
    city: string;
    description: string;
    img: string;
    percentage: number;

    constructor(city : string, description : string, img: string, percentage: number) {
        {
        this.city = city;
        this.description = description;
        this.img = img;
        this.percentage = percentage;
        }
    }
}